import React, { useEffect, useState } from 'react';
import './Resume.css';

export default function Resume() {
  const [resume, setResume] = useState(null);

  useEffect(() => {
    const basePath = process.env.PUBLIC_URL || '';
    fetch(`${basePath}/data/resume.json`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => setResume(data))
      .catch(error => console.error('Error fetching resume data:', error));
  }, []);

  if (!resume) {
    return null;
  }

  return (
    <div className="resume-container">
      <div className="resume-header">
        <h1>{resume.name}</h1>
        <p className="resume-subtitle">{resume.title} · {resume.location}</p>
        <div className="resume-links">
          <a href={`mailto:${resume.email}`}>{resume.email}</a>
          <a href={`tel:${resume.phone.replace(/[^\d+]/g, '')}`}>{resume.phone}</a>
          <a href={resume.github} target="_blank" rel="noopener noreferrer">GitHub</a>
          <a href={resume.linkedin} target="_blank" rel="noopener noreferrer">LinkedIn</a>
        </div>
        <a href={resume.resumeFile} download className="btn">Download Resume (PDF)</a>
      </div>

      <p className="resume-summary">{resume.summary}</p>

      <div className="resume-section">
        <h2>Experience</h2>
        {resume.experience.map((job, index) => (
          <div className="resume-job" key={index}>
            <div className="resume-job-header">
              <h3>{job.role} — {job.company}</h3>
              <span className="resume-job-dates">{job.dates}</span>
            </div>
            <p className="resume-job-location">{job.location}</p>
            {job.subtitle && <p className="resume-job-subtitle">{job.subtitle}</p>}
            {job.intro && <p className="resume-job-intro">{job.intro}</p>}
            <ul>
              {job.bullets.map((bullet, bIndex) => (
                <li key={bIndex}>{bullet}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="resume-section">
        <h2>Skills</h2>
        <div className="resume-skills">
          {resume.skills.map((group, index) => (
            <div className="resume-skill-group" key={index}>
              <h4>{group.category}</h4>
              <p>{group.items.join(', ')}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="resume-section">
        <h2>Speaking</h2>
        <ul>
          {resume.speaking.map((talk, index) => (
            <li key={index}>
              <strong>{talk.title}</strong>, {talk.date}. {talk.description}
            </li>
          ))}
        </ul>
      </div>

      <div className="resume-section">
        <h2>Education</h2>
        <ul>
          {resume.education.map((edu, index) => (
            <li key={index}>{edu.degree} — {edu.school}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
